var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04559 1.91331L7.74143 6.60914C7.95726 6.82498 7.95726 7.17498 7.74143 7.39081L3.04559 12.0866C2.82976 12.3025 2.47976 12.3025 2.26393 12.0866C2.04809 11.8708 2.04809 11.5208 2.26393 11.305L6.56893 6.99998L2.26393 2.69498C2.04809 2.47914 2.04809 2.12914 2.26393 1.91331C2.47976 1.69748 2.82976 1.69748 3.04559 1.91331Z",
    fill: "#BEB6F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeChevronRight);
export default __webpack_public_path__ + "static/media/shape_chevron_right.1a51425e59aa808ab3164558d813034d.svg";
export { ForwardRef as ReactComponent };